module.exports = __webpack_public_path__ + "img/pcba_08@2x.8482c2bd.png";